import { render, staticRenderFns } from "./GuidedSubstanceRegulationContent.vue?vue&type=template&id=6b7837be&scoped=true&"
import script from "./GuidedSubstanceRegulationContent.vue?vue&type=script&lang=js&"
export * from "./GuidedSubstanceRegulationContent.vue?vue&type=script&lang=js&"
import style0 from "./GuidedSubstanceRegulationContent.vue?vue&type=style&index=0&id=6b7837be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7837be",
  null
  
)

export default component.exports